<script setup lang="ts">
import {Loader2Icon} from "lucide-vue-next";
import {useConfigurationStore} from "../../stores/configuration.ts";

const configurationStore = useConfigurationStore()

</script>

<template>
    <Loader2Icon v-if="configurationStore.loading" class="w-12 h-12 animate-spin text-secondary-700"></Loader2Icon>
    <template v-else>
        <slot/>
    </template>
</template>
